<template>
  <div>

    <Row style="border-left: 5px solid #009688;margin-bottom: 5px">
      <Col span="3">销售额: <Tag color="error">{{countData.total_price || 0}} 元</Tag></Col>
      <Col span="3">平台收入: <Tag color="error">{{countData.total_plate_income || 0}} 元</Tag></Col>
      <Col span="3">待退款订单: {{countData.refund_order_num || 0}}</Col>
    </Row>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :doneFunction="doneFunction"
               :defaultPageSize="20"
               :pageSizeOptions="[20,50,100]"
               tableApi="admin/order/getCompanyOrderLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="id">
          <Input type="text" v-model="searchData.id" placeholder="ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="order_no">
          <Input type="text" v-model="searchData.order_no" placeholder="订单号|上游|下游" class="lx-search-item"></Input>
        </FormItem>
        <!-- <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机、姓名、车牌" class="lx-search-item"></Input>
        </FormItem> -->
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>
        <!--<FormItem prop="user_name">
          <Input type="text" v-model="searchData.user_name" placeholder="姓名" class="lx-search-item"></Input>
        </FormItem>
        -->
        <FormItem prop="station_id">
            <Select v-model="searchData.station_id" :filterable="true" :remote-method="getStationsByName" :loading="isLoadingStation" placeholder="站点" clearable>
                <Option v-for="item in stations" :value="item.station_id" :key="item.station_id" v-if="item.station_id">{{item.name}} -- {{ item.platform }}</Option>
            </Select>
        <!--<Input type="text" v-model="searchData.station_name" placeholder="站点名称" class="lx-search-item"></Input>-->
          <!--<Select v-model="searchData.station_id" :filterable="true" placeholder="站点" clearable>
            <Option v-for="item in stations" :value="item.id" :key="item.station_id">{{item.name}}</Option>
          </Select>-->
        </FormItem>
        <FormItem prop="company_id" >
          <Select v-model="searchData.company_id" :filterable="true" placeholder="车队" clearable>
            <Option v-for="item in companys" :value="item.id" :key="item.company_id" v-if="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        
        
        <FormItem prop="platform">
          <Select v-model="searchData.platform" placeholder="渠道" clearable>
            <Option v-for="(item,key) in platform" :value="item.id" :key="key" v-if="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <FormItem prop="refund_status" >
          <Select v-model="searchData.refund_status" placeholder="退款状态" clearable>
            <Option value="1">退款中</Option>
            <Option value="5">已退款</Option>
          </Select>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" @on-change="timeChange" placeholder="购买时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>

    </pageTable>

    <userEditForm v-if="showUserDetail"
                  :show-edit="showUserDetail"
                  :user_id="editUserId"
                  ref="editModel"
                  @cancel-edit="showUserDetail=false"
    >
    </userEditForm>

    <orderDetail v-if="showOrderDetail"
                  :show-edit="showOrderDetail"
                  :order_id="editOrderId"
                  ref="orderDetail"
                  @cancel-edit="showOrderDetail=false"
    >
    </orderDetail>

    <!-- 价格调整对话框 -->
    <Modal v-model="showAdjustModal" title="车队价格调整" :mask-closable="true" width="600" class-name="adjust-modal">
      <div class="adjust-modal-content">
        <div class="order-info">
          <div class="info-row">
            <span class="label">订单号:</span>
            <span class="value">{{currentOrder.order_no}}</span>
          </div>
          <div class="info-row">
            <span class="label">订单ID:</span>
            <span class="value">{{currentOrder.order_id}}</span>
          </div>
        </div>
        <Form :model="adjustForm" :label-width="100" class="adjust-form">
          <FormItem label="调整金额(元)">
            <InputNumber 
              v-model="adjustForm.price_adjust" 
              :precision="2" 
              :step="0.01"
              :active-change="false"
              placeholder="正数增加，负数减少" 
              class="adjust-input"
            ></InputNumber>
            <div class="form-tip">💡 提示: 调整车队单价，输入正数表示加价，负数表示减价<br>如原价5.6元，想调整为5.5元，输入-0.1</div>
          </FormItem>
          <FormItem label="调整说明" required>
            <Input 
              v-model="adjustForm.remark" 
              type="textarea" 
              :rows="4" 
              placeholder="请详细说明价格调整原因" 
              maxlength="200"
              show-word-limit
            ></Input>
          </FormItem>
          <FormItem label="授权密码" required v-if="false">
            <Input 
              v-model="adjustForm.password" 
              type="password" 
              placeholder="请输入授权密码" 
              password
            ></Input>
            <div class="form-tip">提示: 只有授权人员才能进行价格调整</div>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="resetAdjust" size="large">重置</Button>
        <Button type="primary" @click="handleAdjust" :loading="adjustLoading" size="large">提交调整</Button>
      </div>
    </Modal>

    <!-- 调整历史对话框 -->
    <Modal v-model="showHistoryModal" title="价格调整历史" width="1000" :mask-closable="true" class-name="history-modal">
      <div class="history-table-wrapper">
        <Table 
          :columns="historyColumns" 
          :data="adjustHistory" 
          border
          stripe
          no-data-text="暂无调整记录"
        ></Table>
      </div>
    </Modal>


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import userEditForm from "../user/edit";
  import orderDetail from "./detail";
  import XLSX from 'xlsx'

  export default {
    name: "lists",
    components:{pageTable,userEditForm,orderDetail},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        editOrderId:0,     //编辑的ID
        showOrderDetail:false,
        status:0,
        searchData: {
          mobile: '',
          nick_name:'',
          car_number:'',
          create_time:'',
          refund_status:'',
          gas_name:'',
          company_id:'',
          export_type:'ty',
          user_name:'',
          id:'',
          order_no:'',
          station_id: '',  // 站点ID字段，使用空字符串而非null
          platform: ''  // 渠道字段
        },
        tableColumn: [
          {title:'ID',key:'order_id',width:90,align:'center'},
          {
            title: '订单',
            key: 'order_id',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              const items = [
                params.row.order_no ? `单号：${params.row.order_no}` : '',
                params.row.out_trade_no ? `上游：${params.row.out_trade_no}` : '',
                params.row.partner_trade_no ? `下游：${params.row.partner_trade_no}` : ''
              ].filter(Boolean).map(text => h('div', text));
              return h('div', items);
            }
          },
          {
            title: '司机信息',
            key: 'order_id',
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              const items = [
                params.row.user_name ? `姓名：${params.row.user_name}` : '',
                params.row.user_mobile ? `手机号：${params.row.user_mobile}` : ''
              ].filter(Boolean).map(text => h('div', text));
              return h('div', items);
            }
          },
          // {title:'上游订单号',key:'out_trade_no',align:'center'},
          // {title:'下游订单号',key:'partner_trade_no',align:'center'},
          {title:'车牌号',key:'car_number',minWidth:100,align:'center'},
          {title:'车队',key:'company_name',minWidth:100,align:'center',render:(h,params)=>{
              return h('div',[
                h('p',params.row.company_name),
                h('Tag',{props:{color:'blue'}},params.row.company_is_bill===1 ? 'A型' : 'B型'),
              ])
            }},
          {title:'油站',key:'gas_name',minWidth:100,align:'center',render:(h,params)=>{
            return h('div',[
              h('p',params.row.gas_name),
              h('Tag',{props:{color:'orange'}},params.row.platform),
            ])
          }},
          {title:'凭证',key:'proof',width:160,minWidth:100,align:'center',render:(h,params)=>{
              if (params.row.proof_car==='' && params.row.proof_station === ''){
                return h('span','未上传');
              }else{
                let content = [];
                if (params.row.proof_car !== ''){
                  content.push(h('img',{
                    attrs:{src:params.row.proof_car,loading:'lazy',decoding:'async'},
                    style:{width:'60px',height:'60px'
                    },
                    on:{click:()=>{this.showProof(params.row)}}
                  }))
                }
                if (params.row.proof_station !== ''){
                  content.push(h('img',{
                    attrs:{src:params.row.proof_station,loading:'lazy',decoding:'async'},
                    style:{width:'60px',height:'60px'
                    },
                    on:{click:()=>{this.showProof(params.row)}}
                  }))
                }
                if (params.row.proof_mileage !== ''){
                  content.push(h('img',{
                    attrs:{src:params.row.proof_mileage,loading:'lazy',decoding:'async'},
                    style:{width:'60px',height:'60px'
                    },
                    on:{click:()=>{this.showProof(params.row)}}
                  }))
                }
                return h('div',content)
              }
            }},
          {title:'数量(升)',key:'litre_num',minWidth:70,align:'center'},
          {title:'消费金额',key:'total_price',minWidth:180,align:'center',render:(h,params)=>{
            if (params.row.sub_orders && params.row.sub_orders.length > 0) {
              const content = [];
              params.row.sub_orders.forEach((subOrder) => {
                const companyName = this.getSubOrderCompanyName(subOrder);
                content.push(h('div', `主体: ${companyName}, 扣款: ${subOrder.actualPayAmount}元`));
              });
              content.push(h('div', `总金额: ${params.row.total_price}元`));
              return h('div', content);
            }
            return h('span',`${params.row.company_price} * ${params.row.litre_num} = ${params.row.company_amount}`)
            }},
          {
            title: '挂牌价',minWidth:80,align:'center',key:'ndrc_price'
          },
          {title:'成本A',minWidth:100,align:'center',render:(h,params)=>{
            let status=this.status
            if(status){
              return h('span','***')
            }else{
              return h('span',`${params.row.gas_price} * ${params.row.litre_num} = ${params.row.station_amount}`)
            }
          }},
          {title:'成本B',minWidth:100,align:'center',render:(h,params)=>{
            let status=this.status
            if(status){
              return h('span','***')
            }else{
              return h('span',`${params.row.no_bill_price} * ${params.row.litre_num} = ${params.row.no_bill_amount}`)
            }
          }},
          {title:'收款方式',key:'pay_by_name',minWidth:90,align:'center'},
          {title:'下单时间',key:'create_time',minWidth:100,align:'center',width:170},
          {title:'操作',minWidth:100,align:'center',width:120,fixed:'right',render:(h,params)=>{
            if (params.row.refund_status===0 && params.row.order_status===5){
              const buttons = [
                h('Button',{props:{type:'error',size:'small'},on:{click:()=>{this.refund(params.row.order_id)}}},'退款')
              ];
              // 补单不显示价格调整按钮
              if (params.row.pay_by !== 'payByAdmin') {
                buttons.push(
                  h('div',{style:{marginTop:'6px',textAlign:'center'}},[
                    h('Button',{props:{type:'primary',size:'small'},style:{width:'100%',fontSize: '11px'},on:{click:()=>{this.showAdjustDialog(params.row)}}},'车队价格调整')
                  ])
                );
              }
              // 只有有调整记录时才显示查看按钮
              if (params.row.adjust_history_count > 0) {
                buttons.push(
                  h('div',{style:{marginTop:'6px',textAlign:'center'}},[
                    h('Button',{props:{type:'warning',size:'small'},style:{width:'100%',fontSize: '11px'},on:{click:()=>{this.viewAdjustHistory(params.row)}}},'查看调整记录')
                  ])
                );
              }
              return h('div', buttons);
            }else if(params.row.refund_status===1) {
              return  h('div',[
                h('p','退款中'),
                h('p',[
                  h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.cancelRefund(params.row.order_id)}}},'驳回'),
                  h('Button',{props:{type:'error',size:'small'},on:{click:()=>{this.refund(params.row.order_id)}}},'退款'),
                ])
              ])
            }else if(params.row.refund_status===5) {
              //return h('span','已退款')
              return h('div', [
                h('p', '已退款'),
                params.row.refund_apply_remark ? h('p', {style: {fontSize: '12px', color: '#ed4014'}}, `原因: ${params.row.refund_apply_remark}`) : null
              ])
            }else{
              return h('span','未知状态')
            }
            }},
        ],
        tableData: [],
        countData:{},
        stations:[],
        isLoadingStation:false,
        companys:[],
        companyNameMap:{},
        platform:[],
        refundRemark:'',
        showAdjustModal: false,
        showHistoryModal: false,
        currentOrder: {},
        adjustForm: {
          price_adjust: 0,
          remark: '',
          password: ''
        },
        adjustLoading: false,
        adjustHistory: [],
        historyColumns: [
          {
            title: '调整ID',
            key: 'id',
            width: 80
          },
          {
            title: '调整金额',
            key: 'price_diff',
            width: 120,
            render: (h, params) => {
              const value = parseFloat(params.row.price_diff);
              const color = value >= 0 ? '#19be6b' : '#ed4014';
              return h('span', {
                style: { color: color, fontWeight: 'bold' }
              }, value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2));
            }
          },
          {
            title: '原价格',
            key: 'old_company_price',
            width: 100,
            render: (h, params) => {
              return h('span', parseFloat(params.row.old_company_price).toFixed(2) + ' 元');
            }
          },
          {
            title: '新价格',
            key: 'new_company_price',
            width: 100,
            render: (h, params) => {
              return h('span', parseFloat(params.row.new_company_price).toFixed(2) + ' 元');
            }
          },
          {
            title: '调整说明',
            key: 'remark',
            minWidth: 200
          },
          {
            title: '操作人',
            key: 'admin_name',
            width: 120
          },
          {
            title: '调整时间',
            key: 'add_time',
            width: 180
          }
        ]
      }
    },
    methods: {
      getSubOrderCompanyName(subOrder){
        const companyId = subOrder.company_id || subOrder.enterpriseNo || '';
        if (subOrder.company_name) return subOrder.company_name;
        if (subOrder.companyName) return subOrder.companyName;
        if (companyId !== '' && this.companyNameMap[companyId]) return this.companyNameMap[companyId];
        return companyId !== '' ? `车队ID:${companyId}` : '未知车队';
      },
      showDetail(order_id){
        this.editOrderId = order_id
        this.showOrderDetail = true
      },
      showUserDetailPage(user_id){
        this.showUserDetail = true
        this.editUserId = user_id
      },
      reloadDetail(user_id){
        this.showUserDetail = false
        this.$nextTick(()=>{
          this.showUserDetailPage(user_id)
        })
      },
      doneFunction(res){
        this.countData = res.extra
      },
      exportData(){
        this.$commonFun.postProxy('admin/order/exportCompanyOrder',this.searchData).then((res)=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`车队订单.xlsx`)
          })
        })
      },
      showProof(info){
        let images = [];
        if (info.proof_car !== '') images.push(info.proof_car);
        if (info.proof_station !== '') images.push(info.proof_station);
        if (info.proof_mileage !== '') images.push(info.proof_mileage);
        this.$viewerApi({
          images: images,
          options: {
            initialViewIndex: 0,
          },
        })
      },
      refund(order_id){
        this.$Modal.confirm({
          title:'退款',
          render:(h)=>{
            return h( 'Input', {
              size: "large",
              modelValue: this.refundRemark,
              autofocus: true,
              placeholder: '请输入退款原因',
              on:{
                input:(val)=>{
                  this.refundRemark = val;
                }
              }
            })
          },
          loading: true,
          onCancel: () => {
            this.refundRemark = ''
          },
          onOk: async ()=>{
            if (!this.refundRemark || this.refundRemark.trim() === '') {
              this.$Message.error('退款原因不能为空');
              this.$Modal.remove()
              return;
            }
            let res = await this.$commonFun.postProxy('admin/order/refund',{order_id,remark:this.refundRemark});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
                this.refundRemark = ''
              })
            })
          }
        })
      },
      cancelRefund(order_id){
        this.$Modal.confirm({
          title:'驳回退款',
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/order/cancelRefund',{order_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
                this.refundRemark = ''
              })
            })
          }
        })
      },
      async getStationsByName(query){
        if (!query) return ;
        let params = {name:query}
        this.isLoadingStation = true
        let res = await this.$commonFun.postProxy('admin/order/getStationsByName',params)
        this.isLoadingStation = false
        if(res && res.data){
          this.stations = res.data
        }
      },
      timeChange(time) {
        console.log(time)
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchData.create_time = time
        }
      },
      // 显示价格调整对话框
      showAdjustDialog(order) {
        this.currentOrder = order;
        this.showAdjustModal = true;
        this.resetAdjust();
        // 如果订单已支付，加载调整历史
        if (order.pay_status == 1 || order.is_pay == 1) {
          this.loadAdjustHistory(order.order_id);
        }
      },
      // 加载调整历史
      async loadAdjustHistory(order_id) {
        let res = await this.$commonFun.postProxy('admin/order/getOrderAdjustHistory', {order_id});
        this.$commonFun.dealApiResult(res, () => {
          console.log('调整历史数据:', res.data);
          this.adjustHistory = res.data || [];
          if (this.adjustHistory.length > 0) {
            this.showHistoryModal = true;
          }
        });
      },
      // 查看调整记录
      async viewAdjustHistory(order) {
        this.currentOrder = order;
        let res = await this.$commonFun.postProxy('admin/order/getOrderAdjustHistory', {order_id: order.order_id});
        this.$commonFun.dealApiResult(res, () => {
          this.adjustHistory = res.data || [];
          if (this.adjustHistory.length > 0) {
            this.showHistoryModal = true;
          } else {
            this.$Message.info('暂无调整记录');
          }
        });
      },
      // 执行价格调整
      handleAdjust() {
        // 验证调整金额
        if (this.adjustForm.price_adjust === 0 || this.adjustForm.price_adjust === null || this.adjustForm.price_adjust === undefined) {
          this.$Message.warning('请输入调整金额');
          return;
        }
        
        // 验证调整说明
        if (!this.adjustForm.remark || this.adjustForm.remark.trim() === '') {
          this.$Message.warning('请填写调整说明');
          return;
        }
        
        // 验证调整说明长度
        if (this.adjustForm.remark.trim().length < 5) {
          this.$Message.warning('调整说明至少需要5个字符');
          return;
        }
        
        // 构建确认信息
        const adjustType = this.adjustForm.price_adjust > 0 ? '加价' : '减价';
        const adjustAmount = Math.abs(this.adjustForm.price_adjust).toFixed(2);
        const confirmTitle = `确认${adjustType} ${adjustAmount} 元`;
        const confirmContent = `
          <div style="text-align: left; padding: 10px 0;">
            <p><strong>订单号：</strong>${this.currentOrder.order_no}</p>
            <p><strong>订单ID：</strong>${this.currentOrder.order_id}</p>
            <p><strong>调整类型：</strong><span style="color: ${this.adjustForm.price_adjust > 0 ? '#19be6b' : '#ed4014'}">${adjustType}</span></p>
            <p><strong>调整金额：</strong><span style="color: ${this.adjustForm.price_adjust > 0 ? '#19be6b' : '#ed4014'}; font-weight: bold;">${this.adjustForm.price_adjust > 0 ? '+' : '-'}${adjustAmount} 元</span></p>
            <p><strong>调整说明：</strong>${this.adjustForm.remark}</p>
            <p style="color: #ed4014; margin-top: 10px; font-size: 12px;">⚠️ 此操作不可撤销，请仔细核对！</p>
          </div>
        `;
        
        // 显示确认对话框
        this.$Modal.confirm({
          title: confirmTitle,
          content: confirmContent,
          width: 500,
          loading: true,
          onOk: async () => {
            this.adjustLoading = true;
            try {
              let res = await this.$commonFun.postProxy('admin/order/adjustOrderPrice', {
                order_id: this.currentOrder.order_id,
                price_adjust: this.adjustForm.price_adjust,
                remark: this.adjustForm.remark
                // password: this.adjustForm.password
              });
              this.$Modal.remove();
              this.$commonFun.dealApiResult(res, async () => {
                this.$Message.success('价格调整成功');
                this.showAdjustModal = false;
                this.resetAdjust();
                // 刷新列表
                this.$refs.table.getLists();
                // 重新加载调整历史
                await this.loadAdjustHistory(this.currentOrder.order_id);
              });
            } catch (error) {
              this.$Modal.remove();
              this.$Message.error('价格调整失败：' + (error.message || '未知错误'));
            } finally {
              this.adjustLoading = false;
            }
          }
        });
      },
      // 重置表单
      resetAdjust() {
        this.adjustForm = {
          price_adjust: 0,
          remark: '',
          password: ''
        };
      },
      // 处理路由参数的方法（从 mounted 中提取）
      handleRouteParams(query) {
        const { create_time, gas_name, company_id, station_id } = query;
        
        // 重置筛选条件
        this.searchData.create_time = null;
        this.searchData.station_id = '';
        this.searchData.gas_name = '';
        this.searchData.company_id = '';
        
        let hasQueryParam = false;
        
        // 处理日期参数
        if (create_time) {
          const startTime = `${create_time} 00:00:00`;
          const endTime = `${create_time} 23:59:59`;
          this.searchData.create_time = [startTime, endTime];
          hasQueryParam = true;
        }
        
        // 处理车队ID参数
        if (company_id) {
          this.searchData.company_id = company_id;
          hasQueryParam = true;
        }
        
        // 处理站点ID参数（优先于gas_name）
        if (station_id) {
          this.searchData.station_id = Number(station_id); // 转换为数字类型
          hasQueryParam = true;
          
          // 直接触发表格查询
          setTimeout(() => {
            if (this.$refs.table) {
              this.$refs.table.getLists();
            }
          }, 100);
        } else if (gas_name) {
          // 如果没有station_id，才使用gas_name进行匹配
          const decodedGasName = decodeURIComponent(gas_name);
          
          // 如果站点列表已加载，立即处理
          if (this.stations.length > 0) {
            this.matchAndSetStation(decodedGasName, hasQueryParam);
          } else {
            // 否则等待站点列表加载（减少重试次数和间隔）
            let retryCount = 0;
            const maxRetries = 10; // 从20减少到10
            const checkInterval = setInterval(() => {
              retryCount++;
              
              if (this.stations.length > 0 || retryCount >= maxRetries) {
                clearInterval(checkInterval);
                this.matchAndSetStation(decodedGasName, hasQueryParam);
              }
            }, 50); // 从100ms减少到50ms
          }
        } else if (hasQueryParam && this.$refs.table) {
          // 只有日期或车队ID参数，直接查询
          setTimeout(() => {
            this.$refs.table.getLists();
          }, 100); // 从200ms减少到100ms
        }
      },
      
      // 匹配并设置站点
      matchAndSetStation(decodedGasName, hasQueryParam) {
        // 尝试精确匹配
        let matchedStation = this.stations.find(station => station.name === decodedGasName);
        
        // 如果精确匹配失败，尝试模糊匹配（包含关系）
        if (!matchedStation) {
          matchedStation = this.stations.find(station => 
            station.name.includes(decodedGasName) || 
            decodedGasName.includes(station.name)
          );
        }
        
        if (matchedStation) {
          this.searchData.station_id = matchedStation.station_id;
          hasQueryParam = true;
        } else {
          // 即使没找到站点，也使用gas_name作为搜索条件
          this.searchData.gas_name = decodedGasName;
          hasQueryParam = true;
        }
        
        // 触发表格查询
        if (hasQueryParam && this.$refs.table) {
          this.$nextTick(() => {
            this.$refs.table.getLists();
          });
        }
      },
      // 检查是否显示成本信息
      checkShowCost() {
        // 这里可以根据权限或其他条件来控制是否显示成本
        // 目前默认不隐藏（status=0 表示显示）
        this.status = 0;
      },
      getRestrict(){
        this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['companys','platform','oil_station']}).then((res)=>{
          // 加载站点列表
          if (res.data.oil_station) {
            this.stations = res.data.oil_station
          }
          this.companys = res.data.companys || []
          const companyMap = {}
          this.companys.forEach((item)=>{
            if (item.id !== undefined && item.id !== null) companyMap[item.id] = item.name
            if (item.company_id !== undefined && item.company_id !== null) companyMap[item.company_id] = item.name
          })
          this.companyNameMap = companyMap
          this.platform = res.data.platform
          this.checkShowCost() //控制 是否显示 "成本A、成本B"
          
          // API 返回后，再处理路由参数（确保所有数据已加载）
          const { create_time, gas_name, company_id, station_id } = this.$route.query
          this.handleRouteParams({ create_time, gas_name, company_id, station_id });
        })
      },
    },
    watch: {
      // 监听路由参数变化，处理 keep-alive 缓存后的参数更新
      '$route.query': {
        handler(newQuery) {
          this.handleRouteParams(newQuery);
        },
        immediate: false // 不在初始化时执行，由 mounted 处理
      }
    },
    mounted() {
      this.getRestrict();
    },
  }
</script>

<style scoped lang="less">
/* 价格调整对话框样式 */
.adjust-modal-content {
  padding: 10px 0;
  
  .order-info {
    background: #f8f8f9;
    padding: 12px 16px;
    border-radius: 4px;
    margin-bottom: 20px;
    border-left: 3px solid #2d8cf0;
    
    .label {
      color: #515a6e;
      font-weight: 500;
      margin-right: 8px;
    }
    
    .value {
      color: #2d8cf0;
      font-weight: 600;
      font-size: 14px;
    }
  }
  
  .adjust-form {
    /deep/ .ivu-form-item {
      margin-bottom: 20px;
    }
    
    /deep/ .ivu-form-item-label {
      font-weight: 500;
      color: #515a6e;
    }
    
    .adjust-input {
      /deep/ .ivu-input-number {
        width: 100%;
      }
    }
    
    .form-tip {
      margin-top: 8px;
      font-size: 12px;
      color: #ed4014;
      line-height: 1.6;
      font-weight: 500;
    }
  }
}

/* 调整历史表格样式 */
.history-table-wrapper {
  max-height: 500px;
  overflow-y: auto;
  
  /* 自定义滚动条 */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #dcdee2;
    border-radius: 4px;
    
    &:hover {
      background: #c5c8ce;
    }
  }
  
  &::-webkit-scrollbar-track {
    background: #f8f8f9;
    border-radius: 4px;
  }
}

/* 操作按钮样式优化 */
/deep/ .ivu-btn-small {
  padding: 4px 10px;
  font-size: 12px;
}
</style>
